<template>
    <div>
        <div class="top">
            <p>我的直属下级</p>
            <p>{{tuandui.length}}</p>
        </div>
        <div class="list">
            <div class="list_top">
                <p>头像/姓名</p>
                <p>电话</p>
                <p>我的收益</p>
            </div>
            <div class="kong">123</div>
            <div class="list_but" v-for="item in tuandui" :key="item.user_id">
                <span>
                    <img :src="item.avatar" alt="" v-show="sshow">
                    <img src="../assets/touxinag.jpg" alt="" v-show="ashow">
                    {{item.user_nicename}}
                </span>
                <span>{{item.mobile}}</span>
                <span class="fr">+ 0.00</span>
            </div>
        </div>
    </div>
</template>

<script>
import URL from '../api/index'
export default {
    data(){
        return{
            tuandui:[],
            sshow:false,
            ashow:true
        }
    },
    mounted(){
        let tonken=this.$route.query.token
        console.log(tonken); 
        this.$axios({
            method:'post',
            url:URL.getmyterm,
            data:{
                token:tonken
            }
        }).then((res)=>{
            console.log(res);
            
            this.tuandui = res.data.result
            var sum = res.data.result
            for(var i = 0;i<sum.length;i++){
                console.log(sum[i].avatar);
                if(sum[i].avatar == '' || sum[i].avatar == ' '){
                    this.ashow = true
                    this.sshow = false
                } else{
                    this.ashow = false
                    this.sshow = true
                }
            }
        })
    },
    methods:{
        
    }
}
</script>

<style scoped>
.top{
    text-align: center;
    position: fixed;
    top: 46px;
    left: 0;
    width: 100%;
    background-color: #fff;
    z-index: 2;
}
.top p:first-child{
    font-size: 14px;
    color: #2f2f2f;
}
.top p:last-child{
    font-size: 36px;
}
.list{
    position: relative;
}
.list_top{
    width: 100%;
    display: flex;
    text-align: center;
    font-size: 14px;
    color: #757575;
    border-bottom: 1px solid #757575;
    position: fixed;
    top: 194px;
    left: 0;
    background-color: #fff;
    z-index: 2;
}
.list_top p{
    flex: 0.33
}
.kong{
    height: 194px;
    text-indent: -999999px;
}
.list_but{
    display: flex;
    text-align: center;
}
.list_but span {
    flex: 0.33;
    line-height: 50px;
    font-size: 14px;
    color: #2f2f2f;
}
img{
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    vertical-align: middle;
}
.fr{
    color: #ed3638 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/team_top.vue